import Index from '../components/Index.vue';

export const routes_pt = [
    {
        name: 'Index',
        path: '/',
        component: Index,
    }
];